// ============================================================
//  src/utils/helpers.js
// ============================================================

/**
 * Format a number as Nigerian Naira
 */
export function formatNaira(amount, showSymbol = true) {
  const num = parseFloat(amount) || 0;
  const formatted = num.toLocaleString('en-NG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return showSymbol ? `₦${formatted}` : formatted;
}

/**
 * Format a date string to readable format
 */
export function formatDate(dateStr, includeTime = false) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const opts = { day: 'numeric', month: 'short', year: 'numeric' };
  if (includeTime) { opts.hour = '2-digit'; opts.minute = '2-digit'; }
  return d.toLocaleDateString('en-GB', opts);
}

/**
 * Relative time (e.g. "3 mins ago")
 */
export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1)   return 'just now';
  if (mins < 60)  return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs  < 24)  return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7)   return `${days}d ago`;
  return formatDate(dateStr);
}

/**
 * Extract error message from axios error
 */
export function getError(err) {
  return (
    err?.response?.data?.message ||
    err?.response?.data?.msg    ||
    err?.message                ||
    'Something went wrong. Please try again.'
  );
}

/**
 * Truncate a string
 */
export function truncate(str, max = 40) {
  if (!str) return '';
  return str.length > max ? str.slice(0, max) + '…' : str;
}
